import { render, staticRenderFns } from "./SignInRecord.vue?vue&type=template&id=712b5110"
import script from "./SignInRecord.vue?vue&type=script&lang=js"
export * from "./SignInRecord.vue?vue&type=script&lang=js"
import style0 from "./SignInRecord.vue?vue&type=style&index=0&id=712b5110&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports